//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The constant identifier for the Columbus View {@link SceneMode}\n\
 *\n\
 * @name czm_sceneModeColumbusView\n\
 * @glslConstant\n\
 * @see czm_sceneMode\n\
 * @see czm_sceneMode2D\n\
 * @see czm_sceneMode3D\n\
 * @see czm_sceneModeMorphing\n\
 */\n\
const float czm_sceneModeColumbusView = 1.0;\n\
";